import i18n from '../locales/i18n';
import ptBR from 'date-fns/locale/pt-BR';
import enUS from 'date-fns/locale/en-US';

const DATE_LOCALES = {
  'pt-BR': ptBR,
  en: enUS,
};

export default function getDateLocale() {
  return DATE_LOCALES[i18n.language] || DATE_LOCALES['pt-BR'];
}
